import { render, staticRenderFns } from "./FavoriteBrands.vue?vue&type=template&id=c7cc0280"
import script from "./FavoriteBrands.vue?vue&type=script&lang=js"
export * from "./FavoriteBrands.vue?vue&type=script&lang=js"
import style0 from "./FavoriteBrands.vue?vue&type=style&index=0&id=c7cc0280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports